<template>
  <div
    class="modal fade"
    id="auto-notifications"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            id="auto-notification-close"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">
              {{ $t("notifications.automatic_notifications_app") }}
            </h4>
          </div>
          <div class="row g-6">
            <div class="col-md-6">
              <label class="form-label" for="selectpickerBasic">{{
                $t("accounts.username")
              }}</label>
              <div class="input-group input-group-merge">
                <input
                  value="{username}"
                  type="text"
                  class="form-control"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  disabled
                  id="username-input"
                />
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  id="button-addon2"
                  @click="copyToClip('username-input')"
                >
                  <i class="ti ti-copy ti-s "></i>
                </button>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="selectpickerBasic">{{
                $t("profiles.name") + " " + $t("profiles.profile")
              }}</label>
              <div class="input-group input-group-merge">
                <input
                  value="{profile_name}"
                  type="text"
                  class="form-control"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  id="profile-name-input"
                  disabled
                />
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  id="button-addon2"
                  @click="copyToClip('profile-name-input')"
                >
                  <i class="ti ti-copy ti-s "></i>
                </button>
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label" for="selectpickerBasic">{{
                $t("accounts.full_name")
              }}</label>
              <div class="input-group input-group-merge">
                <input
                  value="{full_name}"
                  type="text"
                  class="form-control"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  disabled
                  id="full-name-input"
                />
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  id="button-addon2"
                  @click="copyToClip('full-name-input')"
                >
                  <i class="ti ti-copy ti-s "></i>
                </button>
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label" for="selectpickerBasic">{{
                $t("profiles.price") + " " + $t("profiles.profile")
              }}</label>
              <div class="input-group input-group-merge">
                <input
                  value="{profile_price}"
                  type="text"
                  class="form-control"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  disabled
                  id="profile-price-input"
                />
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  id="button-addon2"
                  @click="copyToClip('profile-price-input')"
                >
                  <i class="ti ti-copy ti-s "></i>
                </button>
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label" for="selectpickerBasic">{{
                $t("accounts.expires_at")
              }}</label>
              <div class="input-group input-group-merge">
                <input
                  value="{expires_at}"
                  type="text"
                  class="form-control"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  disabled
                  id="expires-at-input"
                />
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  id="button-addon2"
                  @click="copyToClip('expires-at-input')"
                >
                  <i class="ti ti-copy ti-s "></i>
                </button>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="selectpickerBasic">{{
                $t("notifications.config.expiring_enabled")
              }}</label>
              <div class="input-group">
                <span class="input-group-text">{{
                  $t("notifications.config.expiring_body")
                }}</span>

                <div class="input-group-text">
                  <input
                    class="form-check-input mt-0"
                    v-model="config.notifications_expiring_enabled"
                    type="checkbox"
                    aria-label="Checkbox for following text input"
                  />
                </div>
                <textarea
                  :style="text_direction"
                  class="form-control"
                  @input="validate"
                  v-model="config.notifications_expiring_body"
                  :disabled="!config.notifications_expiring_enabled"
                  :class="{ 'is-invalid': errors.expiring }"
                  aria-label="SSR Comment"
                ></textarea>
                <div v-if="errors.expiring" class="invalid-feedback">
                  {{ errors.expiring }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="selectpickerBasic"
                >{{ $t("notifications.config.expired_enabled") }}
              </label>
              <div class="input-group">
                <span class="input-group-text">{{
                  $t("notifications.config.expired_body")
                }}</span>

                <div class="input-group-text">
                  <input
                    v-model="config.notifications_expired_enabled"
                    class="form-check-input mt-0"
                    type="checkbox"
                    aria-label="Checkbox for following text input"
                  />
                </div>
                <textarea
                  class="form-control"
                  :style="text_direction"
                  @input="validate"
                  v-model="config.notifications_expired_body"
                  :disabled="!config.notifications_expired_enabled"
                  :class="{ 'is-invalid': errors.expired }"
                  aria-label="SSR Comment"
                ></textarea>
                <div v-if="errors.expired" class="invalid-feedback">
                  {{ errors.expired }}
                </div>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="selectpickerBasic">{{
                $t("notifications.config.renew_enabled")
              }}</label>
              <div class="input-group">
                <span class="input-group-text">{{
                  $t("notifications.config.renew_body")
                }}</span>

                <div class="input-group-text">
                  <input
                    class="form-check-input mt-0"
                    type="checkbox"
                    v-model="config.notifications_renew_enabled"
                    aria-label="Checkbox for following text input"
                  />
                </div>
                <textarea
                  class="form-control"
                  :style="text_direction"
                  @input="validate"
                  v-model="config.notifications_renew_body"
                  :disabled="!config.notifications_renew_enabled"
                  aria-label="SSR Comment"
                ></textarea>
                <div v-if="errors.renew" class="invalid-feedback">
                  {{ errors.renew }}
                </div>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <button
                class="btn btn-success"
                @click.prevent="store"
                :disabled="!validated"
              >
                {{ $t("profiles.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "notificationsAuto",
  async created() {
    this.loading = true;
    const response = await axios.get("notifications/config");
    if (response.status == 200) {
      var temp = response.data.data;
      temp.forEach((element) => {
        switch (element.key) {
          case "notifications_expiring_enabled":
            this.config.notifications_expiring_enabled = element.value == 1;
            break;
          case "notifications_expiring_body":
            this.config.notifications_expiring_body = element.value;
            break;
          case "notifications_expired_enabled":
            this.config.notifications_expired_enabled = element.value == 1;
            break;
          case "notifications_expired_body":
            this.config.notifications_expired_body = element.value;
            break;
          case "notifications_renew_enabled":
            this.config.notifications_renew_enabled = element.value == 1;
            break;
          case "notifications_renew_body":
            this.config.notifications_renew_body = element.value;
            break;
          default:
            break;
        }
      });
    }
    this.loading = false;
    this.validate();
  },
  data() {
    return {
      config: {
        notifications_expiring_enabled: false,
        notifications_expiring_body: "",
        notifications_expired_enabled: false,
        notifications_expired_body: "",
        notifications_renew_enabled: false,
        notifications_renew_body: "",
      },
      loading: false,
      errors: {
        expiring: null,
        expired: null,
        renew: null,
      },
      validated: true,
      text_direction:
        this.$i18n.locale == "ar" ? "direction:rtl" : "direction:ltr",
    };
  },
  methods: {
    async store() {
      this.loading = true;
      const response = await axios.post("notifications/config", this.config);
      if (response.status == 200) {
        document.getElementById("auto-notification-close").click();
        this.$notify({
          text: "Notifications Updated Successfully",
          type: "success",
        });
        this.loading = false;
        this.$emit("updated");
      }
      this.loading = false;
    },
    copyToClip(id) {
      // Get the text field
      var copyText = document.getElementById(id);

      // Select the text field
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
      this.$notify({
        text: "Copied to clipboard!",
        type: "info",
      });
    },
    validate() {
      this.validated = true;
      this.errors.expiring = null;
      this.errors.expired = null;
      this.errors.renew = null;
      if (this.config.notifications_expiring_body == "") {
        this.errors.expiring = this.$t("errors.notifications.empty");
        this.validated = false;
      }
      if (this.config.notifications_expired_body == "") {
        this.errors.expired = this.$t("errors.notifications.empty");
        this.validated = false;
      }
      if (this.config.notifications_renew_body == "") {
        this.errors.renew = this.$t("errors.notifications.empty");
        this.validated = false;
      }
    },
  },
};
</script>
